import { render, staticRenderFns } from "./DataGridPopoverPage.vue?vue&type=template&id=051088a8"
import script from "./DataGridPopoverPage.vue?vue&type=script&lang=js"
export * from "./DataGridPopoverPage.vue?vue&type=script&lang=js"
import style0 from "./DataGridPopoverPage.vue?vue&type=style&index=0&id=051088a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports